import { Utilities } from 'src/app/services/utilities';
import { SingleSelectControl } from './SingleSelectControl';
import { AbstractControl, Validators } from '@angular/forms';


export class MultiSelectControl extends SingleSelectControl {

    buildInitialFormControlValue() {
        const keyField = Utilities.camelize(this.variable.displayMetadata && this.variable.displayMetadata.templateData && this.variable.displayMetadata.templateData.keyField);

        return this.variable.displayMetadata?.templateData?.list.filter(i => this.variable && this.variable.value && (this.variable.value as any[]).some(x => x == i.key));
    }

    getValue(item: any): any {
        if (item) {
            const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
            const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
            const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

            let result = wrapperValue;
            if (wrapperValue && propertyName) {
                result = wrapperValue[propertyName];
            }

            return result;
        } else {
            const result = this.formControl.value;
            return result != null ? result.filter(i => i).map(i => i[this.keyField]) : result;
        }
    }

    getDisplayValue(item: any): any {
        const tempData = this.variable.displayMetadata.templateData;
        if (tempData && tempData.keyField) {
            if (item) {
                const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
                const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
                const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

                let result = wrapperValue;
                if (wrapperValue && propertyName) {
                    result = wrapperValue[propertyName];
                }

                return result;
            } else {
                const result = this.variable.value;
                return result != null ? result.filter(i => i).map(i => i[this.keyField]) : result;
            }
        } else {
            return tempData;
        }
    }

    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
